/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { PatchedLocationDescriptor } from 'js/lib/connectToRouter';

import ExitButton from 'bundles/grading/components/common/ExitButton';

const styles = {
  container: () => css`
    background-color: var(--cds-color-neutral-background-primary);
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    width: 100%;
    height: 64px;
    box-shadow: 0 1px 4px rgb(0 0 0 / 8%);
    z-index: 10;
    padding: var(--cds-spacing-100);
  `,
};

type Props = {
  routeOnClose: PatchedLocationDescriptor;
  exitButtonOverrideComponent?: React.ReactNode;
  children?: React.ReactNode;
};

const TopBar: React.FC<Props> = ({ routeOnClose, exitButtonOverrideComponent, children }) => {
  return (
    <div css={styles.container}>
      {exitButtonOverrideComponent || <ExitButton routeOnClose={routeOnClose} />}
      {children}
    </div>
  );
};

export default TopBar;
